import { render, staticRenderFns } from "./AddSaleMan.vue?vue&type=template&id=4a0380cc&scoped=true&"
import script from "./AddSaleMan.vue?vue&type=script&lang=ts&"
export * from "./AddSaleMan.vue?vue&type=script&lang=ts&"
import style0 from "./AddSaleMan.vue?vue&type=style&index=0&id=4a0380cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0380cc",
  null
  
)

export default component.exports